export default {
    setCountry(state, data) {
        state.currentCountry = data;
    },
    setMessages(state, data) {
        state.messages = data;
    },
    setLanguage(state, data) {
        state.currentLanguge = data;
    },
    setLanguages(state, data) {
        state.langs = data;
    },
    setCountries(state, data) {
        state.countries = data;
    },
    setMinimumOrderPrice(state, data) {
        state.minimumOrderPrice = data;
    },
    setStatusPpsCourier(state, data) {
        state.statusPpsCourier = data;
    },
    setStatusPpsCourierPreorderPayment(state, data) {
        state.statusPpsCourierPreorderPayment = data;
    },
    setMainMenu(state, data) {
        state.mainMenu = data;
    },
    setBanner(state, data) {
        state.banner = data;
    },
    setProductBlocks(state, data) {
        state.productBlocks = data;
    },
    setUserHasOrders(state, data) {
        state.userHasOrders = data;
    },
};
